import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LGEDataService } from 'src/commons';
import { ConfirmModalComponent } from '..';


@Component({
    selector: 'override-user-modal',
    templateUrl: './overried-user-details.component.html',
    styleUrls: ['./overried-user-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverrideUserDetailsComponent implements OnInit, OnDestroy {
    @Input() title: string;
    @Input() message: string;
    @Input() userData: any;
    @Input() MGList: any;
    @Input() SM_ECList: any;
    @Input() ECList: any;

    overrideUser: FormGroup;
    isEditMode: boolean;
    isReadOnly = false;
    confirm: any;

    constructor(
        private _dataService: LGEDataService,
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<OverrideUserDetailsComponent>,
        private fb: FormBuilder, @Inject(MAT_DIALOG_DATA) private data: any) {
        this.message = data.message;
        this.title = data.title;
        this.userData = data.userData;
        this.MGList = data.MGList;
        this.SM_ECList = data.SM_ECList;
        this.ECList = data.ECList;
        this.isEditMode = data.isEditMode;
    }

    ngOnInit() {
        this.createForms();
    }

    private createForms(): void {
        this.overrideUser = this.fb.group({
            'EmpId': [''],
            'DepartmentName': [''],
            'FirstName': [''],
            'LastName': [''],
            'Email': [''],
            'Title': [''],
            'managerCC': [''],
            'managerCA': [''],
            'director': [''],
            'VP_CR_CA': [''],
            'LOB_VP1': [''],
            'LOB_VP2': [''],
            'CP_CEO': [''],
            'orId': [null],
            'approverLevelId': [null],
            'deleteIt': [false],
        });
        this.overrideUser.setValue(this.userData);
    }

    public showConfirm(title: string, message: string) {
        this.confirm = this.dialog.open(ConfirmModalComponent, {
            width: '350px',
            disableClose: false,
            data: { title: title, message: message }
        });
    }

    onSubmit() {
        this.showConfirm('Are you sure you want to submit?', '');
        this.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                this.dialogRef.close(this.overrideUser.value);
            }
        });
    }

    onCancel() {
        this.dialogRef.close();
    }

    onUpdate() {
        this.showConfirm('Are you sure you want to update?', '');
        this.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                this.dialogRef.close(this.overrideUser.value);
            }
        });
    }

    onDelete() {
        this.showConfirm('Are you sure you want to delete?', '');
        this.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                this.overrideUser.value.deleteIt = true;
                this.dialogRef.close(this.overrideUser.value);
            }
        });
    }

    ngOnDestroy() {

    }
}
